import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { addPageData, navigateWizard } from '../../actions';
import Button from '../../components/Button';
import PageLayout from '../../components/PageLayout';
import RadioButtons from '../../components/RadioButtons';
import analytics from '../../lib/analytics';
import * as payloadFactory from '../../lib/pageDataPayloadFactory';

const radioOptions = ['Female', 'Male', 'Non-conforming'];

const GenderPage = ({ initialGender, dispatchAddPageData, dispatchWizardNav }) => {
  const [gender, setGender] = useState(initialGender || '');

  const handleSubmit = e => {
    e.preventDefault();

    if (isInvalid) {
      return;
    }

    analytics.sendEvent('Click - Next', 'gender');

    dispatchAddPageData(payloadFactory.createAddPageDataPayload('gender', gender));
    dispatchWizardNav({ dir: 'fwd' });
  };

  const onChangeGender = e => setGender(e.target.value);

  const handleApplyDefault = e => {
    e.preventDefault();

    analytics.sendEvent('Click - Prefer not to say', 'gender');

    dispatchAddPageData(payloadFactory.createAddPageDataPayload('gender', null));
    dispatchWizardNav({ dir: 'fwd' });
  };

  const isInvalid = radioOptions.indexOf(gender) === -1;

  return (
    <PageLayout
      title="What is your gender?"
      helpText="Don't worry, your gender selection won't affect your chances of getting a loan. We use this to measure social impact and manage investor requirements."
    >
      <form className="row-spacer" onSubmit={handleSubmit}>
        <div className="row">
          <div className="col col--auto">
            <RadioButtons
              radioOptions={radioOptions}
              defaultOption={gender}
              onChange={onChangeGender}
            />
          </div>
        </div>
        <div className="mt-12">
          <Button type="submit" isDisabled={isInvalid}>
            Next
          </Button>
        </div>
      </form>

      <div className="row-spacer">
        <p>
          <Link to="/test-taken" onClick={handleApplyDefault}>
            Prefer not to say.
          </Link>
        </p>
      </div>
    </PageLayout>
  );
};

GenderPage.propTypes = {
  initialGender: PropTypes.string,
  dispatchAddPageData: PropTypes.func.isRequired,
  dispatchWizardNav: PropTypes.func.isRequired,
};

GenderPage.defaultProps = {
  initialGender: '',
};

export const mapStateToProps = reduxState => ({
  initialGender: reduxState.builder.ui.gender,
});

export const mapDispatchToProps = {
  dispatchAddPageData: addPageData,
  dispatchWizardNav: navigateWizard,
};

export { GenderPage };

export default connect(mapStateToProps, mapDispatchToProps)(GenderPage);
